const determineHost = () => {
    let serviceHost;
    const hostname = window && window.location && window.location.hostname;
    const host = hostname.toLowerCase();
    const prodRegex = /^reporthub.emlpayments.net$/;
    const prodMatch = host.match(prodRegex);
    const qaRegex = /(alpha|bravo|charlie|delta|foxtrot-[0-9]{1,2})/;
    const qaMatch = host.match(qaRegex);
    const testRegex = /(xtest|uat)/;
    const testMatch = host.match(testRegex);  
  
    if (prodMatch) {
      //prod
      serviceHost = "webservices.storefinancial.net";
    } else if (qaMatch) {
      //we are in one of the four QA envirnoments, concatenate appropriate host
      serviceHost = "webservices-" + qaMatch[0] + ".storefinancialdev.net";
    } else if (testMatch) {
      //we are in xtest test environment
      serviceHost = "webservices." + testMatch[0] + ".storefinancial.net";
    } else {
      // local
      serviceHost = "local.storefinancialdev.net";
    }
  
    return serviceHost;
  };
  
  export const API_ROOT = `https://${determineHost()}`;
  